import React from 'react';
import PropTypes from 'prop-types';
import { NameContainer, SpanResponsible } from './styles';

const NameValue = ({ name, isResponsible, wordingIsResponsible, device }) => {
  return (
    <NameContainer>
      {name}
      {isResponsible ? <SpanResponsible device={device}>{wordingIsResponsible}</SpanResponsible> : null}
    </NameContainer>
  );
};

NameValue.prototype = {
  name: PropTypes.string.isRequired,
  isResponsible: PropTypes.bool.isRequired,
  wordingIsResponsible: PropTypes.string.isRequired
};

export default NameValue;
